'use strict';
import React, { PureComponent } from 'react';


class DatosReproceso extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
  
    }

    formatearFecha(fecha) {
      
        var fechaObj = new Date(fecha);
    
        var dia = fechaObj.getDate();
        var mes = fechaObj.getMonth() + 1; // Sumar 1 porque los meses van de 0 a 11
        var año = fechaObj.getFullYear();
    
        dia = (dia < 10) ? '0' + dia : dia;
        mes = (mes < 10) ? '0' + mes : mes;
    
        return dia + '/' + mes + '/' + año;
    }


    render() {
        const {
            estaDesplegado,
            registro,
            registroDatosReproceso
        } = this.props;


        return (
            <div className={"AsientosContables__modalDetalleAsiento__contenedorDatosReprocesoRegistro slider-tarjetas" + (estaDesplegado ? "" : " closed AsientosContables__modalDetalleAsiento__contenedorDetalleSuperiorAuditoriaReproceso--Inactivo")}>
            
                <div className="AsientosContables__modalDetalleAsiento__datosReprocesoregistro AsientosContables__modalDetalleAsiento__DatosReprocesoregistro--Cabecera AsientosContables--overflowHidden">
                    <div className="AsientosContables__DatosReproceso__FechaReproceso AsientosContables--floatLeft">FECHA REPROCESO</div>
                    <div className="AsientosContables__DatosReproceso__Usuario AsientosContables--floatLeft">USUARIO</div>
                    <div className="AsientosContables__DatosReproceso__Terminal AsientosContables--floatLeft">TERMINAL</div>
                    <div className="AsientosContables__DatosReproceso__FechaEnvioReverso AsientosContables--floatLeft">FECHA ENVIO REVERSO</div>
                    <div className="AsientosContables__DatosReproceso__TotalDebito AsientosContables--floatLeft">TOTAL DÉBITO</div>
                    <div className="AsientosContables__DatosReproceso__TotalCredito AsientosContables--floatLeft">TOTAL CRÉDITO</div> 
                </div>
                <div className="modalLogIntentosScroll AsientosContables__scrollGrilla--reproceso">
                {registroDatosReproceso && registroDatosReproceso.length > 0 && registroDatosReproceso.map((registroReproceso, index) => (
                    <div key={index} className="AsientosContables__modalDetalleAsiento__datosReprocesoregistro AsientosContables--overflowHidden">
                        <div className="AsientosContables__DatosReproceso__FechaReproceso AsientosContables--floatLeft">{registroReproceso.FechaReproceso ? this.formatearFecha(registroReproceso.FechaReproceso) : '-'}</div>
                        <div className="AsientosContables__DatosReproceso__Usuario AsientosContables--floatLeft">{registroReproceso.UsuarioEliminacion}</div>
                        <div className="AsientosContables__DatosReproceso__Terminal AsientosContables--floatLeft">{registroReproceso.TerminalEliminacion}</div>
                        <div className="AsientosContables__DatosReproceso__FechaEnvioReverso AsientosContables--floatLeft">{registroReproceso.FechaEnvioReverso ? this.formatearFecha(registroReproceso.FechaEnvioReverso) : '-'}</div>
                        <div className="AsientosContables__DatosReproceso__TotalDebito AsientosContables--floatLeft">
                
                        {registroReproceso.TotalImputadoCredito !== null && registroReproceso.TotalImputadoCredito !== 0 && (
                             <div>${registroReproceso.TotalImputadoDebito}</div>
                            )}

                          {registroReproceso.TotalImputadoCreditoDolar !== null && registroReproceso.TotalImputadoCreditoDolar !== 0 && (
                             <div className="AsientosContables__CreditoDebitoDolares">US$ {registroReproceso.TotalImputadoDebitoDolar}</div>
                            )}

                        </div>
                        <div className="AsientosContables__DatosReproceso__TotalCredito AsientosContables--floatLeft">

                            {registroReproceso.TotalImputadoCredito !== null && registroReproceso.TotalImputadoCredito !== 0 && (
                             <div>${registroReproceso.TotalImputadoCredito}</div>
                              )}

                            {registroReproceso.TotalImputadoCreditoDolar !== null && registroReproceso.TotalImputadoCreditoDolar !== 0 && (
                            <div className="AsientosContables__CreditoDebitoDolares">US$ {registroReproceso.TotalImputadoCreditoDolar}</div>
                              )}

                        </div>
                    </div>
                ))}
            </div>
            </div>
        );
    }
}

export default DatosReproceso;